/**
 * MetricCard variant styles (class-variance-authority)
 * @layer atom
 * @package @plerity/ui-core
 *
 * Extracted to a leaf module so MetricCard.tsx and MetricCard.types.ts can both
 * import `cardVariants` without forming a MetricCard.tsx <-> MetricCard.types.ts
 * import cycle (import-cycles-packages baseline, 2026-09-15). Re-exported from
 * MetricCard.tsx so the public `@plerity/ui-core` import path is unchanged.
 */

import { cva } from "class-variance-authority";

// `min-w-0` allows the card to shrink inside flex/grid parents (so the
// truncate on the value inside actually engages instead of pushing the
// card wider than its container).
// Literal white/gray-800 surfaces — do NOT use `bg-surface` or
// `border-[var(--color-border-default)]` here. Those emit `var(--color-*)` with
// NO fallback and are stripped from the React SPA apps' Tailwind v4 build.
export const cardVariants = cva("min-w-0 rounded-lg border p-4 shadow-sm transition-shadow hover:shadow-md", {
  variants: {
    variant: {
      default: "border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800",
      elevated: "border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800",
      outlined: "border-gray-200 bg-transparent dark:border-gray-700",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
